import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import VueResource from 'vue-resource';
import VueJwtDecode from 'vue-jwt-decode';
import swal from 'sweetalert';

Vue.config.productionTip = false;

Vue.use(VueJwtDecode);
Vue.use(VueResource);

Vue.http.options.root = 'https://psicometricosfapsi.com/fod/api/public/pri';

localStorage.apikeySiepsFodUanl=JSON.stringify("eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJzaWVwc191YW5sX3RfbWVkaWNhIiwiZGF0YSI6eyJpZHNvbGljaXR1ZCI6IjEiLCJpZGFsdW1ubyI6IjEifSwiaWF0IjoxNzA1Mzg2ODQxLCJleHAiOjIwMjEwMDYwNDF9.fezmnUW5vTlsGUxwWrPZcCAquCLCp3Mu_Sg8fey5Dxk");

Vue.http.interceptors.push((request, next) => {
  if (!localStorage.getItem('apikeySiepsFodUanl') || localStorage.getItem('apikeySiepsFodUanl')=='undefined' || localStorage.getItem('apikeySiepsFodUanl')==undefined) {
    localStorage.apikeySiepsFodUanl=JSON.stringify("eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJzaWVwc191YW5sX3RfbWVkaWNhIiwiZGF0YSI6eyJpZHNvbGljaXR1ZCI6IjEiLCJpZGFsdW1ubyI6IjEifSwiaWF0IjoxNzA1Mzg2ODQxLCJleHAiOjIwMjEwMDYwNDF9.fezmnUW5vTlsGUxwWrPZcCAquCLCp3Mu_Sg8fey5Dxk");
  }
  request.headers.set('Authorization', 'Bearer '+JSON.parse(localStorage.apikeySiepsFodUanl))
  request.headers.set('Accept', 'application/json')
  next(res => {
  })
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js